// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cm-2";
export var aiChatCartContainerExit = "_cm-4";
export var aiChatContainerLarge = "_cm-0";
export var aiChatContainerSmall = "_cm-1";
export var aiChatIcon = "_cm-6";
export var slideInFromRight = "_cm-3";
export var slideOutToRight = "_cm-5";